import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import KontaktSectionHeadersWhitePattern2 from '../components/headers-white-pattern/KontaktSectionHeadersWhitePattern2';
import KontaktSectionContactsWhitePattern4 from '../components/contacts-white-pattern/KontaktSectionContactsWhitePattern4';
import KontaktSectionFootersGrayPattern5 from '../components/footers-gray-pattern/KontaktSectionFootersGrayPattern5';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Kontakt() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <KontaktSectionHeadersWhitePattern2 />
      <KontaktSectionContactsWhitePattern4 />
      <KontaktSectionFootersGrayPattern5 />
    </React.Fragment>
  );
}

